import React from 'react';
import { useImages } from '../../context';
import FramiProgress from './FramiProgress';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { NetworkMonitor } from '../../utilities';

const NoWrap = styled.div`
    white-space: nowrap;
    margin-right: 8px;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 2px;
    align-items: center;
`;

const StatusIndicator = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
    margin-left: 8px;
    color: ${props => props.$isOffline ? '#ef4444' : '#10b981'};
`;

const PhotoUploadProgress = () => {
    const { uploadProgress } = useImages();
    const intl = useIntl();
    const networkStatus = NetworkMonitor.getConnectionStatus();

    if (!uploadProgress || uploadProgress === 100) {
        return null;
    }
    
    return (
        <Wrapper>
            <NoWrap>
                {intl.formatMessage({ id: 'common.photos_upload' })}:
            </NoWrap>
            <FramiProgress percent={uploadProgress}/>
            <StatusIndicator $isOffline={!networkStatus.isOnline}>
                {networkStatus.isOnline ? '🌐' : '⚠️'}
                {networkStatus.isOnline ? 'Online' : 'Offline'}
            </StatusIndicator>
        </Wrapper>
    );
};

export default PhotoUploadProgress;
